import Slide from './Slide'
import * as S from './elements'
import { Icon, SliderIndicators, Track, useSlider } from '@gassan-ui'
import { ContentSlide } from '@lib/kontent/models/ContentSlide'
import { FC, useRef } from 'react'

type Props = {
  items: ContentSlide[]
}

const InfoBlockSlider: FC<Props> = ({ items }) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index } = useSlider({ trackRef })

  return (
    <div className="relative mx-auto max-w-[90rem] sm:w-[calc(100%-4rem)] lg:mb-40 lg:w-[calc(100%-5.5rem)] xl:mb-60">
      <Track ref={trackRef} onTouchEnd={onTouchEnd}>
        {items.map((item, key) => (
          <Slide key={key} isActive={key === index} {...item} />
        ))}
      </Track>

      {items.length > 1 && (
        <>
          <div className="flex justify-center pb-8 sm:pb-12 lg:hidden">
            <SliderIndicators active={index} total={items.length} />
          </div>
          <S.NavButton onClick={prev} isLeft disabled={!canMoveLeft}>
            <Icon icon="chevron-left" />
          </S.NavButton>
          <S.NavButton onClick={next} disabled={!canMoveRight}>
            <Icon icon="chevron-right" />
          </S.NavButton>
        </>
      )}
    </div>
  )
}

export default InfoBlockSlider
